import * as yup from "yup"

export const schema = yup.object().shape({
  zipCode: yup
    .string()
    .length(5, "Please enter a valid zip code")
    .required("Please enter your zip code"),
})
